import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import styled from "styled-components";
import LeftArrow from "../../../../../images/placeholders/left-arrow-carousal-gray.svg";
import RightArrow from "../../../../../images/placeholders/right-arrow-caroual-gray.svg";
import { Video } from "@mindmemobile/mm-shared-global";
import { MediaModel } from "../models";

interface CarouselProps {
  media: MediaModel[] | null;
  className?: string;
}

const CustomCarouselWrapper = styled.div`
  width: 100%;
  position: relative;

  .main-image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 0 auto;
    /* max-width: 430px; */ //creating issue in checkout page
    max-width: 280px;
    width: auto;
    height: 230px;
    /* height: 150px; // 20-01, latest changes  */
    &.without-thumbnail {
      max-width: 100%;
    }

    .carousel-arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      color: #333;
      cursor: pointer;
      z-index: 2;

      &:hover {
        color: #000;
      }
      img {
        height: 40px;
        width: 20px;
      }
    }

    .left-arrow {
      left: -40px;
    }

    .right-arrow {
      right: -40px;
    }

    .carousel-inner {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      img,
      video {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 20px;
        max-height: 230px;
      }
      video {
        max-width: 100%;
        object-fit: contain;
      }
    }
    .carousel-item {
      display: none;
      align-items: center;
      justify-content: center;
      transition:
        transform 0.4s ease-in-out,
        opacity 0.4s ease-in-out;

      &.active {
        display: flex;
        opacity: 1;
      }
    }
  }

  .thumbnail-container {
    display: flex;
    justify-content: center;
    gap: 25px;
    /* overflow-x: auto; */
    width: 100%;
    align-items: center;
    margin: 30px auto 0;

    &::-webkit-scrollbar {
      width: 0.7em;
      height: 0.4em;
      background-color: #15283717;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      outline: 1px solid #ddd;
      background-color: rgba(21, 40, 55, 0.3);
      border-radius: 10px;
    }
    &.overflow-thumbnail {
      justify-content: flex-start;
      overflow-x: auto;
    }

    .thumbnail-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      opacity: 0.6;

      &.active {
        opacity: 1;
      }

      .thumbnail {
        border: 2px solid transparent;
        border-radius: 10px;
        max-width: 80px;
        max-height: 80px;
        object-fit: cover;
        min-width: 50px;
        min-height: 50px;
      }

      .underline {
        display: none;
        width: 50%;
        height: 3px;
        background-color: #aaaaaa;
        margin-top: 5px;
        border-radius: 2px;
      }

      &.active .underline {
        display: block;
      }
    }
  }
  @media (min-width: 280px) and (max-width: 375px) {
    .main-image-wrapper {
      max-width: 150px; // need to change this to 220px as it appears very small
      height: 160px;
      .left-arrow {
        left: -40px;
      }
      .right-arrow {
        right: -40px;
      }
      &.without-thumbnail {
        max-width: 100%;
      }
     .carousel-inner .carousel-item img{
        max-height: 160px;
      }
    }
  }
  @media (min-width: 376px) and (max-width: 468px) {
    .main-image-wrapper {
      max-width: 150px !important;
      height: 160px;
      .left-arrow {
        left: -40px;
      }
      .right-arrow {
        right: -40px;
      }
      &.without-thumbnail {
        max-width: 100%;
      }
      .carousel-inner .carousel-item img{
        max-height: 160px;
      }
    }
  }
  @media (min-width: 468px) and (max-width: 576px) {
    .main-image-wrapper {
      max-width: 170px !important;
      height: 160px;
      .carousel-inner .carousel-item img{
        max-height: 160px;
      }
     
    }
  }
  @media (min-width: 469px) and (max-width: 1024px) {
    .main-image-wrapper {
      max-width: 220px;
      .left-arrow {
        left: -70px;
      }
      .right-arrow {
        right: -70px;
      }
      &.without-thumbnail {
        max-width: 100%;
      }
    }
  }
  @media (min-width: 1025px) and (max-width: 1300px) {
    .main-image-wrapper {
      max-width: 220px;
      .left-arrow {
        left: -60px;
      }
      .right-arrow {
        right: -60px;
      }
      &.without-thumbnail {
        max-width: 100%;
      }
    }
  }

  @media (max-width: 1400px) {
    .main-image-wrapper .carousel-inner video {
      max-width: 300px;
    }
  }
`;

const CarouselWithThumbnail: React.FC<CarouselProps> = ({
  media,
  className,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!media || media.length === 0) {
    return null;
  }

  const handleSelect = (selectedIndex: number) => {
    setCurrentIndex(selectedIndex);
  };

  const handleThumbnailClick = (index: number) => {
    setCurrentIndex(index);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : media.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < media.length - 1 ? prevIndex + 1 : 0
    );
  };

  return (
    <CustomCarouselWrapper className={className}>
      <div
        className={`main-image-wrapper ${media.length === 1 ? "without-thumbnail" : ""}`}
      >
        {media.length > 1 && (
          <span className="carousel-arrow left-arrow" onClick={handlePrev}>
            <img src={LeftArrow} alt="Left Arrow" />
          </span>
        )}
        <Carousel
          activeIndex={currentIndex}
          onSelect={handleSelect}
          controls={false}
          indicators={false}
        >
          {media.map((item, index) => (
            <Carousel.Item key={index}>
              {item.type === "Image" && (
                <img
                  src={item.fullURL}
                  alt={`Slide ${index}`}
                  style={{ width: "100%" }}
                />
              )}
              {item.type === "Video" && <Video url={item.fullURL} />}
            </Carousel.Item>
          ))}
        </Carousel>
        {media.length > 1 && (
          <span className="carousel-arrow right-arrow" onClick={handleNext}>
            <img src={RightArrow} alt="Right Arrow" />
          </span>
        )}
      </div>

      {media.length > 1 && (
        <div
          className={`thumbnail-container ${media.length > 4 ? "overflow-thumbnail" : ""}`}
        >
          {media.map((item, index) => (
            <div
              key={index}
              className={`thumbnail-wrapper ${index === currentIndex ? "active" : ""}`}
              onClick={() => handleThumbnailClick(index)}
            >
              {item.type === "Video" ? (
                <video
                  src={item.fullURL}
                  className="thumbnail"
                  style={{ width: "100%", height: "auto" }}
                  muted
                />
              ) : (
                <img
                  src={item.fullURL}
                  alt={`Thumbnail ${index}`}
                  className="thumbnail"
                  style={{ width: "100%", height: "auto" }}
                />
              )}

              <div className="underline" />
            </div>
          ))}
        </div>
      )}
    </CustomCarouselWrapper>
  );
};

export default CarouselWithThumbnail;
